import React, { Dispatch, SetStateAction, useMemo, useState } from 'react';
import DependancyGraph from '../AnalysisConfiguration/WorkflowMonitor/dependancyGraph';
import SearchSelect from 'components/SearchSelect';
import { config } from 'process';
import { useGetAllActivities } from 'api/sdk';
import { useSelector } from 'react-redux';
import { RootState } from 'store';

const InfoPopover: React.FC<{
  model: any;
  selectedWorkflowId: string;
  setSelectedWorkflowId: any;
  isEdit: boolean;
  configId: string;
  handleClose: () => void;
  selectedModel: any;
  setSelectedModel: any;
  setEdit: Dispatch<SetStateAction<boolean>>;
}> = ({
  model,
  configId,
  selectedModel,
  setSelectedModel,
  selectedWorkflowId,
  setSelectedWorkflowId
}) => {
  const { data: allActivities } = useGetAllActivities(configId || '', {
    pipeline_satus: true || null
  });

  console.log('selected model', selectedModel);
  // Generate nodes
  const nodes = useMemo(() => {
    if (model.model_type === 'yolact') {
      const workflowConfig =
        selectedModel[0]?.data?.workflow[0].workflow_config;

      console.log('workflow config inside nodes', workflowConfig);
      return (workflowConfig || []).map((item: any) => ({
        id: item.id,
        data: {
          label: item.label,
          mandatory: item.mandatory
        },
        position: {
          x: 200 * (Math.random() * 2),
          y: 200 * (Math.random() * 2)
        }
      }));
    } else {
      return selectedModel[0]?.data?.workflow.map(
        (item: any, index: number) => ({
          id: item.id,
          data: {
            label:
              allActivities?.data?.activity_details?.find(
                activity => activity.id === item?.activity_id
              )?.activity ?? '',
            mandatory: item.mandatory || false
          },
          position: {
            x: 200 * (index % 3),
            y: Math.floor(index / 3) * 100
          }
        })
      );
    }
  }, [selectedModel]);

  console.log('model data inside info popover', model);

  // Generate edges
  const edges = useMemo(() => {
    if (!selectedModel || !Array.isArray(selectedModel[0]?.data?.workflow)) {
      return []; // Return an empty array if data is not an array
    }

    const uniqueEdges = new Set<string>();

    const allEdges: any[] = [];

    if (model.model_type === 'yolact') {
      const workflowConfig =
        selectedModel[0]?.data?.workflow[0]?.workflow_config;

      if (!workflowConfig) {
        return [];
      }

      return workflowConfig
        .filter(
          (item: any) => item.dependency && Array.isArray(item.dependency)
        )
        .flatMap((item: any) =>
          (item?.dependency || []).map((dep: any) => ({
            id: `e-${dep}-${item.id}`,
            source: dep,
            target: item.id,
            type: 'smoothstep',
            animated: true
          }))
        );
    } else {
      selectedModel[0].data.workflow.flatMap((item: any) =>
        (item?.dependency || []).map((dep: any) => {
          const edgeKey = `${dep}-${item.id}`;
          if (!uniqueEdges.has(edgeKey)) {
            uniqueEdges.add(edgeKey);
            allEdges.push({
              id: `e-${dep}-${item.id}`,
              source: dep,
              target: item.id
            });
          }
          return null;
        })
      );
    }
    return allEdges.filter(Boolean); // Filter out null values
  }, [selectedModel]);

  console.log('nodes and edges', nodes, edges);

  // Handle selection change
  const handleChange = (selectedValue: string) => {
    const filteredModel = model.workflow_configurations.filter(
      (fData: any) => fData?.id === selectedValue
    );
    setSelectedModel(filteredModel || []);
    setSelectedWorkflowId(selectedValue);
  };

  return (
    <div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          gap: '2vw'
        }}
      >
        <div style={{ width: '60%' }}>
          {nodes && edges && <DependancyGraph nodes={nodes} edges={edges} />}
        </div>
        <div className="flex flex-1 flex-col w-[30%] h-full justify-between  ">
          <div className="h-[50vh] flex flex-col items-center">
            <div className="w-full bg-[#102633] text-white py-2 flex items-center justify-center">
              Workflow List
            </div>
            {(model?.workflow_configurations || []).map(
              (workflow: any, index: number) => {
                const isSelected = workflow.id === selectedWorkflowId;
                console.log(
                  isSelected,
                  workflow.id,
                  selectedWorkflowId,
                  'isSelectedisSelected'
                );
                return (
                  <div
                    key={workflow.id}
                    onClick={() => handleChange(workflow.id)}
                    className={`w-full py-2 flex items-center justify-center cursor-pointer transition-all duration-200
        ${isSelected ? 'bg-[#eeeeee] text-black' : 'bg-[#ffffff] text-black'}
        hover:bg-[#eeeeee]`}
                  >
                    {workflow?.name || 'Unnamed'}
                  </div>
                );
              }
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default InfoPopover;
